import { DiscoveryWallState } from '../../../models';
import { DISCOVERY_WALL_MUTATIONS_KEYS } from '../discovery-wall.const';
import { DiscoveryWallMutation } from '../discovery-wall.interfaces';

export class SetDiscoveryWallLoadingMutation implements DiscoveryWallMutation {
  mutations = {
    [DISCOVERY_WALL_MUTATIONS_KEYS.setDiscoveryWallLoading]: (state: DiscoveryWallState, loading: boolean) => {
      state.loading = loading;
    }
  };
}
